module.exports = __webpack_public_path__ + "94998475f6aea65f558494802416c1cf.ttf";